/**
 *Created by jmmartinez on 03/08/2021

 * */

import React from 'react'
import {CELLTIPO_IMAGENLISTA, CELLTIPO_LISTA} from "../ej2/UI/TiposCeldas";
import {filtrarConNombreCampo} from "../ej2/utils/FilterUtils";


export const getCellEditor= (tipo) => {
    switch (tipo){
        case CELLTIPO_IMAGENLISTA: return ImagenesEditor;
        case CELLTIPO_LISTA: return SelectorEditor;
        default: return CadenaEditor;
    }
}


function autoFocusAndSelect(input){
    if (input) {
        input.focus();
        input.select();
    }
}




export function CadenaEditor({row, column, onRowChange, onClose}){
    return (
        <input
            style={{width: '100%'}}
            className="rdg-text-editor"
            ref={autoFocusAndSelect}
            value={row[column.key]}
            onChange={(event) => onRowChange({ ...row, [column.key]: event.target.value })}
            onBlur={() => onClose(true)}
            onKeyUp={(event) => {
                if (column.onColumnCellKeyUp)
                    column.onColumnCellKeyUp(event.keyCode, column, row[column.key]);
            }
            }
        />
    );
}

export  function SelectorEditor({ row, column, onRowChange, onClose }) {
    return (
        <select
            style={{width: '100%'}}
            value={row[column.key]}
            onChange={(event) => onRowChange({ ...row, [column.key]: event.target.value }, true)}
            autoFocus
        >
            {column.valores.map((valor) => (
                <option key={valor.codigo} value={valor.codigo}>
                    {valor.nombre}
                </option>
            ))}
        </select>
    );
}

export function ImagenesEditor({ row, column, onRowChange, onClose }) {
    let imagenSrc= null;
    let imagenesEncontradas = filtrarConNombreCampo(column.imagenes, "valor", row[column.key]);
    if (imagenesEncontradas && imagenesEncontradas.length > 0) {
        let imagen= imagenesEncontradas[0].imagen;
        if (imagen && imagen != "") {
            imagen = "./" + imagen;
            imagenSrc = column.resourcesImages(imagen);
        }
        else{
            imagenSrc = column.resourcesImages("./icon_vacio.png");
        }
    }


    //Para poder capturar el RETURN hemos usado un <input image
    return (
        <div style={{width: '100%', backgroundColor: 'red'}}>
            <input type="image" src={imagenSrc} name="saveForm"
                   ref={autoFocusAndSelect}
                   onBlur={() => onClose(true)}
                   onKeyUp={(event) => {
                       if (column.onColumnCellKeyUp)
                           column.onColumnCellKeyUp(event.keyCode, column, row[column.key]);
                   }
                   }
            />
        </div>

    )
}


export function OnlyKeyditor({row, column, onRowChange, onClose}){
    return (
        <input
            style={{width: '100%'}}
            className="rdg-text-editor"
            ref={autoFocusAndSelect}
            id= "igNesting"
            value=""
            //onChange={}
            //onChange={(event) => onRowChange({ ...row, [column.key]: event.target.value })}
            onBlur={() => onClose(true)}
            onKeyUp={(event) => {
                if (column.onColumnCellKeyUp)
                    column.onColumnCellKeyUp(event.keyCode, column, row[column.key]);
            }
            }
        />
    );
}